import {connectRoutes} from "redux-first-router";
import routesMap from "./routesMap";

const {reducer, middleware, enhancer} = connectRoutes(routesMap);

export const routerReducer = reducer;
export const routerMiddleware = middleware;
export const routerEnhancer = enhancer;
